// 镜片信息组件公共样式

const lensInfoClassName = {
  // 容器样式
  container: 'max-xl:pb-[70px] mb-[5px] w-full',

  // 标题样式
  sectionTitle: 'text-[14px] font-bs mb-[12px] mt-[24px]',

  // 内容行样式
  contentRow: 'flex justify-between items-center mt-[8px] text-[14px]',

  // 颜色描述样式
  colorDescription: 'mt-[8px] text-[14px]',

  // 价格样式
  priceContainer: 'flex items-center',
  originalPrice: (waiMode: boolean) =>
    `o-price notranslate line-through ${waiMode ? '' : 'text-[#93969e]'} mr-[5px] text-[16px]`,
  currentPrice: 'n-price notranslate font-bb text-[16px]',

  // 会员标签样式
  memberTag: 'mr-[5px]',
};

export default lensInfoClassName;
